module.exports = __webpack_public_path__ + "static/jam-jar-pink-6fe161fe73238ff7459af6dfd3ae69ad.svg";